export interface TopScore {
  name: string;
  points: number;
}

export interface UserScore {
  points: number;
  rank: number;
  name: string;
}

export interface TopScoresInfo {
  userScore: UserScore;
  topScores: TopScore[];
}

export interface TopScoreWithRank extends TopScore {
  rank: number;
}
